import { render, staticRenderFns } from "./costDetail.vue?vue&type=template&id=1f7ca1f6&scoped=true"
import script from "./costDetail.vue?vue&type=script&lang=js"
export * from "./costDetail.vue?vue&type=script&lang=js"
import style0 from "./costDetail.vue?vue&type=style&index=0&id=1f7ca1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ca1f6",
  null
  
)

export default component.exports